module.exports = __webpack_public_path__ + "img/compact.28476296.png";